import { setUserData } from '../slices/user.slice';
import { fetchPortfoliosInBatches } from '../../Api/portfolioApi'; // Adjust the import path as needed
import { fetchUpcomingEvents } from '../../Api/tickersApi'; // Adjust the import path as needed
import { HOSTNAME } from '../../Configs/Domain';



export const setLocalStorageOnUserAuthentication = (jwtToken, userDocument) => {
  const acctType = userDocument?.auth?.acct_type ?? 'tracker';
  localStorage.setItem('jwt_token', jwtToken);
  localStorage.setItem('token', userDocument.uid);
  localStorage.setItem('uid', userDocument.uid);
  localStorage.setItem('cid', userDocument?.company?.cid);
  localStorage.setItem('acct_type', acctType === 'tracker' ? 'iq' : acctType);
  localStorage.setItem('_appWhitelist', userDocument?.settings?._app_whitelist ?? []);
  localStorage.setItem('apps', userDocument?.settings?.apps ?? []);
};

export const clearLocalStorageOnUserLogout = () => {
  localStorage.removeItem('jwt_token');
  localStorage.removeItem('uid');
  localStorage.removeItem('cid');
};


export const login = (username, password, setIsLoggedIn, setLoginFailed) => async (dispatch) => {
  try {
    const response = await fetch(`${HOSTNAME}/auth/login/credentials`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ u: username, p: password }),
    });
    const data = await response.json();
    if (response.status !== 200) {
      setLoginFailed(true);
      setIsLoggedIn(false);
      throw new Error(`Login failed: ${data.message || 'Server error'}`);
    }
    setIsLoggedIn(true);
    const userData = data.data;
    setLocalStorageOnUserAuthentication(data.token, userData);
    dispatch(setUserData(userData));
    if (userData) {
      if (userData?.portfolios_v2) {
        const portfolioIds = userData.portfolios_v2.map(p => p.id);
        dispatch(fetchPortfoliosInBatches({userId: userData.uid, portfolioIds, userObjects: userData.portfolios_v2}));
      }
      if (userData?.tickers) {
        dispatch(fetchUpcomingEvents(userData.tickers))
      }
    }
  } catch (error) {
    console.error('Authentication failed:', error);
  }
};
export const logout = () => async (dispatch) => {
  try {
    const response = await fetch(`${HOSTNAME}/auth/logout`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Logout failed');
    }
  } catch (error) {
    console.error('Logout failed:', error);
  }
  clearLocalStorageOnUserLogout();
};
